import { Box, Button, Flex, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import statusOptions from "services/Recruit/data/offerLetterData";


const StatusOfferLetter = ({ row = { values: { status: statusOptions[0].value } } }) => {
  const [status, setStatus] = useState(row?.values?.status || statusOptions[0].value);

  const currentStatus = statusOptions.find((option) => option.value === status) || statusOptions[0];

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="outline"
        px={3}
        py={1}
        borderRadius="md"
        bg="white"
        w="150px"
        _hover={{ borderColor: "gray.400" }}
      >
        <Flex align="center" gap={2}>
          <Box w="10px" h="10px" bg={currentStatus.color} borderRadius="full" />
          <Text fontWeight="bold">{currentStatus.label}</Text>
        </Flex>
      </MenuButton>
      <MenuList>
        {statusOptions.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => setStatus(option.value)}
            _hover={{ bg: "gray.100" }}
          >
            <Flex align="center" gap={2}>
              <Box w="10px" h="10px" bg={option.color} borderRadius="full" />
              <Text>{option.label}</Text>
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default StatusOfferLetter;
